import React from "react";
import PropTypes from "prop-types";
import "./Breadcrumbs.scss";

function Breadcrumbs({ nodes, navigateFn }) {
  const totalNodes = nodes.length;

  return (
    <div className="breadcrumbs" data-testid="breadcrumbs">
      {nodes.map((node, idx) => {
        return (
          <span key={node.label}>
            <button
              className={idx === totalNodes - 1 ? "active" : ""}
              onClick={() => navigateFn(node, idx, totalNodes)}
            >
              {node.label}
            </button>
            {idx < totalNodes - 1 ? <span>/</span> : ""}
          </span>
        );
      })}
    </div>
  );
}

Breadcrumbs.propTypes = {
  nodes: PropTypes.array.isRequired,
  navigateFn: PropTypes.func.isRequired,
};

export default Breadcrumbs;
